import { BaseLoadingSpinner, BaseSkeletonStack, EntityModel } from '@cksoftware/react-base';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Box, Text, DataListItem, DataListRoot } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface InfiniteListProps<T> {
  items: T[];
  emptyListMessage?: string;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isLoading: boolean;
  renderItem: (item: T) => ReactElement;
  height?: number | string;
}

export const InfiniteList = <T extends EntityModel>(props: InfiniteListProps<T>) => {
  const { items, emptyListMessage, fetchNextPage, hasNextPage, isLoading, renderItem, height } = props;
  return (
    <InfiniteScroll
      dataLength={items.length}
      height={height}
      next={fetchNextPage}
      hasMore={hasNextPage}
      loader={
        <Box textAlign='center' py='4'>
          <BaseLoadingSpinner isLoading={isLoading} />
        </Box>
      }
      endMessage={
        <Box textAlign='center' py='4'>
          {emptyListMessage && items.length == 0 && <Text>{emptyListMessage}</Text>}
        </Box>
      }
      scrollableTarget='scrollable-layout'>
      <DataListRoot>
        <BaseSkeletonStack isLoading={isLoading && items.length == 0} />
        {items.map((item) => (
          <DataListItem key={item.Id}>{renderItem(item)}</DataListItem>
        ))}
      </DataListRoot>
    </InfiniteScroll>
  );
};
